import React from 'react';
import { SvgImage } from '../common';
import './styles.scss';

interface EventLocationProps {
  startLocation: string;
  endLocation?: string;
}

const EventLocation = ({
  startLocation,
  endLocation,
}: EventLocationProps) => (
  <div className="event-location">
    <div className="event-location__name">
      <SvgImage title="Location icon" reference="#icon-location" />
      {startLocation}
    </div>
    {endLocation && (
      <div className="event-location__name event-location__name--end">
        <SvgImage title="Location icon" reference="#icon-location" />
        {endLocation}
      </div>
    )}
  </div>
);

export default EventLocation;
